<template>
  <v-snackbar
    v-if="currentMessage"
    v-model="snackbar"
    :multi-line="true"
    :color="currentMessage.color || 'error'"
    :timeout="currentMessage.timeout || defaultTimeout"
  >
    {{ currentMessage && currentMessage.text }}

    <template v-slot:action>
      <v-btn
        color="white"
        text
        dark
        @click="snackbar = false"
      >
        {{ $t('common.close') }}
      </v-btn>
    </template>
  </v-snackbar>

</template>

<script>
export default {
  name: 'SnackBar',
  data () {
    return {
      snackbar: false,
      defaultTimeout: 5000
    }
  },
  computed: {
    messagesQueue () {
      return this.$store.state.messages || []
    },
    currentMessage () {
      return this.messagesQueue.find((m) => !m.isRead)
    }
  },
  watch: {
    snackbar () {
      if (!this.snackbar && this.currentMessage) {
        this.currentMessage.isRead = true
      }
    },
    currentMessage () {
      if (this.currentMessage) {
        setTimeout(() => {
          this.snackbar = true
        }, 100)
      }
    }
  },
  created () {
    this.$eventBus.$on('SHOW_MESSAGE', (message) => {
      if (message.text) {
        this.messagesQueue.push(message)
      }
    })
  }
}
</script>
